// path: src/pages/IPA/Negociacoes/pages/NegociacoesSalvas/colunaDeGrao.ts

/** A decisão de a coluna de grão oferecer ordenação ou não. */

/** Responde se o cabeçalho da coluna de grão deve oferecer ordenação. */
export const colunaDeGraoOfereceOrdenacao = (graosSelecionados?: string[]): boolean => (graosSelecionados ?? []).length !== 1;
